import { render, staticRenderFns } from "./LineDivider.vue?vue&type=template&id=223a109b&scoped=true&"
var script = {}
import style0 from "./LineDivider.vue?vue&type=style&index=0&id=223a109b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a109b",
  null
  
)

export default component.exports